import script from "./PwaInstraction.vue?vue&type=script&setup=true&lang=js"
export * from "./PwaInstraction.vue?vue&type=script&setup=true&lang=js"

import "./PwaInstraction.vue?vue&type=style&index=0&id=64f0a37b&scoped=true&lang=css"

import exportComponent from "/home/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64f0a37b"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QBtn});
